import { checkWord } from "../../wordfill/logic/answers";
import {
  Answer,
  Content,
  ImageLabelTestableWord,
  Label,
  Score,
  TestableWord
} from "../types";

export function markAnswer(content: Content, answer: Answer): Score {
  let score = 0;
  let total = 0;

  const labelScores = content.labels.reduce((labels: any, label: Label) => {
    if (typeof label.word !== "string" && label.word.testing) {
      total++;
      let word = (label.word as TestableWord).word;

      if ((label.word as ImageLabelTestableWord).isMixedDefinition) {
        word = (label.word as ImageLabelTestableWord).testedWord;
      }

      const otherPermittedWords = (label.word as TestableWord)
        .otherPermittedWords
        ? (label.word as TestableWord).otherPermittedWords
        : [];

      if (!answer || !answer.labels || !answer.labels[word]) {
        labels[word] = false;
      } else {
        labels[word] = [word]
          .concat(otherPermittedWords!)
          .some(w => checkWord(w, answer.labels[word]));
        labels[word] && score++;
      }
    }

    return labels;
  }, {});

  return {
    labels: labelScores,
    score: score / total
  };
}

export const generateInitialUserAnswer = () => {
  return {
    labels: {}
  };
};
